/**
 * QaDashboardScreen — Kuutio-specific wrapper for the QA Sidekick dashboard.
 *
 * Provides Kuutio's test items, batch metadata, and AdminHeader.
 * Mounted at /admin/qa in App.jsx. Server-wide: not tied to an instance.
 */
import React from 'react';
import { QaDashboard } from '@qa-sidekick/core/client';
import AdminHeader from '../components/AdminHeader';
import QA_TEST_ITEMS, { QA_BATCHES } from './testItems';

export default function QaDashboardScreen() {
  return (
    <QaDashboard
      items={QA_TEST_ITEMS}
      batches={QA_BATCHES}
      header={<AdminHeader />}
    />
  );
}
